var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightVectorUserAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.182727 1.35435L3.09907 5L0.182727 8.64566C0.114337 8.73112 0.0634504 8.82922 0.0329708 8.93435C0.00249125 9.03948 -0.00698395 9.14959 0.00508631 9.25838C0.0171566 9.36718 0.0505358 9.47253 0.103318 9.56842C0.156101 9.66431 0.227253 9.74887 0.312712 9.81726C0.398171 9.88566 0.496264 9.93655 0.601389 9.96703C0.706514 9.99751 0.816613 10.007 0.925401 9.99492C1.03419 9.98285 1.13953 9.94946 1.23542 9.89668C1.33131 9.84389 1.41586 9.77274 1.48425 9.68727L4.81721 5.52081C4.93553 5.37301 5 5.18933 5 5C5 4.81067 4.93553 4.62699 4.81721 4.47919L1.48425 0.312732C1.34613 0.140128 1.14511 0.0294657 0.925401 0.0050869C0.705695 -0.0192919 0.485304 0.0446119 0.312712 0.182738C0.227253 0.251132 0.156101 0.335689 0.103318 0.431581C0.0505358 0.527474 0.0171566 0.632826 0.00508631 0.74162C-0.0192907 0.961339 0.0446085 1.18174 0.182727 1.35435Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightVectorUserAdmin);
export default __webpack_public_path__ + "static/media/right_Vector_userAdmin.6e37aa4e39e00b15d313a2690d101e66.svg";
export { ForwardRef as ReactComponent };